import { __decorate, __metadata, __param } from "tslib";
import { format } from '@/@core/utils/string';
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
let WorkspaceApi = class WorkspaceApi {
    constructor(http, urls, authService) {
        this.http = http;
        this.urls = urls;
        this.authService = authService;
        this.getSpaceOfUser = (params) => {
            return this.http.get({
                url: this.urls.getSpaceOfUser,
                params,
            });
        };
        this.getTransferHistory = (params) => {
            return this.http.post({
                url: this.urls.getTransferHistory,
                data: params,
            });
        };
        this.transfer = (params) => {
            // const headers = { 'X-User-ID': this.getAuthService() }
            return this.http.post({
                url: this.urls.transfer,
                data: params,
            });
        };
    }
    postTaskAdminQuery(params) {
        return this.http.post({
            url: this.urls.postTaskAdminQuery,
            data: params,
        });
    }
    putCancelTask(admin_id, params) {
        const url = format(this.urls.putCancelTask, {
            admin_id,
        });
        return this.http.put({
            url,
            data: params,
        });
    }
    getTotalTask() {
        throw new Error('');
    }
    getTaskTrend(params) {
        return this.http.post({
            url: `${this.urls.taskChart}/trend`,
            data: params,
        });
    }
    getErrorTaskInfos(params) {
        return this.http.post({
            url: `${this.urls.taskChart}/error-task-list`,
            data: params,
        });
    }
    getTaskType(params) {
        return this.http.post({
            url: `${this.urls.taskChart}/pie-task-type`,
            data: params,
        });
    }
    getTaskStatus(params) {
        return this.http.post({
            url: `${this.urls.taskChart}/pie-task-status`,
            data: params,
        });
    }
    getErrorMax(params) {
        return this.http.post({
            url: `${this.urls.taskChart}/user-group-error-task`,
            data: params,
        });
    }
    getTaskMax(params) {
        return this.http.post({
            url: `${this.urls.taskChart}/user-group-all-task`,
            data: params,
        });
    }
    // #region DataMigration: 数据迁移
    /**
     * 获取用户信息:
     * @returns
     */
    getAuthService() {
        return this.authService.currentUser.id;
    }
    // #endregion
    getWorkspaceSummary(data) {
        return this.http.get({
            url: `${this.urls.summary}`,
            params: data,
            headers: {
                'X-API-Version': '2.0',
            },
        });
    }
    // #region Cold Hot Data
    separateData(params) {
        return this.http.post({
            url: this.urls.separateData,
            data: params,
        });
    }
    mergeData(params) {
        return this.http.post({
            url: this.urls.mergeData,
            data: params,
        });
    }
};
WorkspaceApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.WorkspaceHttp)),
    __param(1, inject(Symbols.WorkspaceApiUrls)),
    __param(2, inject(Symbols.AuthService)),
    __metadata("design:paramtypes", [Object, Object, Object])
], WorkspaceApi);
export { WorkspaceApi };
